import { useState } from "react";
import { getHostBrand, NEUTRAL_PRODUCT } from "../lib/hostConfig";

/** Product name (+ optional logo) for the 3D chrome: the partner brand from window.__CF_SIM__.brand, else the
 *  neutral default. data-mascot is set only when the brand allows the mascot. */
export function BrandMark({
  className,
  logoClassName = "cf-brand-logo",
  onlyWhenBranded = false,
}: {
  className?: string;
  logoClassName?: string;
  onlyWhenBranded?: boolean;
}) {
  const brand = getHostBrand();
  const [logoOk, setLogoOk] = useState(true);
  if (!brand && onlyWhenBranded) return null;
  const name = brand?.product ?? NEUTRAL_PRODUCT;
  return (
    <span className={className} data-branded={brand ? "1" : undefined} data-mascot={brand?.mascot ? "1" : undefined}>
      {brand?.logoUrl && logoOk ? (
        <img
          className={logoClassName}
          src={brand.logoUrl}
          alt=""
          decoding="async"
          referrerPolicy="no-referrer"
          onError={() => setLogoOk(false)}
        />
      ) : null}
      <span className="cf-brand-name">{name}</span>
    </span>
  );
}
